<template>
  <div class="wealthbuilding">
    <div class="centered">
      <div>
        <div v-if="msg.msg && msg.type == 'notice'" :class="['row form-' + msg.type]">
          {{ msg.msg }}
        </div>
        <div class="card">
          <template v-if="step == 0">
            <div class="row">
              <div class="sm-col-12 lg-col-6">
                <customInput
                  ref="focus"
                  v-model="startValue" @click="update" type="money"
                  :label="'Startbedrag (minimaal € 25,-)'" :min="25" :validation="['min']"
                />
                <customInput
                  v-model="depositValue" @click="update"
                  type="money" :label="'Storting per maand'" :validation="['notrequired']"
                />
                <customInput
                  v-model="durationPeriod" :min="1" :max="50" :step="1" unitType="date"
                  @click="update" type="number" name="jaar" label="Looptijd in jaren"
                  :validation="['min', 'max']"
                />
                <div class="fakeinput inputbox" @click="goalModal = true">
                  <div class="label">
                    Streefrendement (doel &euro; {{formatPrice(berekenVermogensopbouw(), true)}})
                  </div>
                  <div class="input">
                    {{formatPrice((Number(extraInterest) / 100)
                    + (wealthTax == 'Yes' ? 1.2 : 0)
                    + (inflation == 'Yes' ? 2 : 0),
                    false,
                    1)}}%
                  </div>
                </div>
              </div>
              <div class="sm-col-12 lg-col-6 riskmeter" @click="meterModal = true">
                <awesomeIcon icon="info-circle" class="info"/>
                <scoreMeter v-model="satScore" :showNotice="false" />
              </div>
            </div>
            <div class="row">
              <h3>Haalbaarheid van uw doel</h3>
              <template v-if="satScore < 50">
                U ziet in de Doelmeter dat uw doelvermogen lastig haalbaar is, naar het rood gaat.
                Als we beleggen volgens
                <b>
                  <a target="_blank" href="https://www.doelbeleggen.nl/content/uploads/2019/09/Beleggingsprofielen-1-12-2016.pdf" >
                    {{ satProfile }}
                  </a>
                </b>
                dan heeft uw doel een haalbaarheid van
                {{ formatPrice(Number(satScore), false, 0) }}%. Dat is aan de lage kant, alles onder
                50% betekent dat u uw doel moeilijk kunt halen. Dat betekent niet dat u niet verder
                kunt, verderop na het aanmelden kunt u uw doelgegevens aanpassen en de haalbaarheid
                weer beter maken.
              </template>
              <template v-else>
                U ziet in de Doelmeter dat uw doelvermogen goed haalbaar is. Als we beleggen volgens
                ons
                <b>
                  <a
                    target="_blank"
                    href="https://www.doelbeleggen.nl/content/uploads/2019/09/Beleggingsprofielen-1-12-2016.pdf"
                  >
                    {{ satProfile }}
                  </a>
                </b>
                dan heeft uw doel een haalbaarheid van
                {{ formatPrice(Number(satScore), false, 0) }}%. Dat is prima, alles boven 50%
                betekent dat u uw doel kunt halen.
              </template>
            </div>
            <div class="buttonbox">
              <button @click="step = 2" class="primary">Volgende</button>
            </div>
          </template>
          <template v-if="step == 2">
            <div class="row">
              <h3>Hoe kan het beleggen verlopen</h3>
              In deze vermogensverwachting ziet u 3 lijnen. Rood als het beleggen slecht verloopt,
              blauw bij een normaal scenario en de groen als het beleggen beter gaat dan verwacht.
              <projectWidget
                :pvvidata="pvviData"
                :target="Number(goalValue)"
                :enddate="targetDate"
                class="graph"
              />
            </div>
            <div class="buttonbox">
              <button @click="step = 3" class="primary">Volgende</button>
              <button @click="step = 0" class="secondary">Terug</button>
            </div>
          </template>
          <template v-if="step == 3">
            <div class="row">
              <h3>Over Doelbeleggen</h3>
              Wij zijn in 2018 &amp; 2019 uitgeroepen tot Beste Online Vermogensbeheerder van
              Nederland. Door het bieden van laagdrempelig, goedkoop en doelgericht beleggen voor
              mensen die dat niet zelf, maar willen laten doen.
              <br><br>
              Meer informatie kunt u vinden op:
              <a
                href="https://www.doelbeleggen.nl/waarom/"
                target="_blank"
              >doelbeleggen.nl/waarom</a>.
              <br><br>
              <h3>Aan de slag</h3>
              Na het invullen van e-mail kunt u de doelgegevens verder afstemmen en brengen we uw
              persoonlijke situatie uitgebreid in kaart. Daarmee maken we uw beleggingsplan en
              bepalen we uw uiteindelijke beleggingsprofiel.
              <br ><br>
              <div v-if="msg.msg && msg.type == 'error'" :class="['row form-' + msg.type]">
                {{ msg.msg }}
              </div>
              <input
                ref="email"
                name="email"
                type="email"
                placeholder="E-mailadres"
                autofocus
                @change="msg.msg = null"
                @keyup.enter="register"
              />
            </div>
            <div class="buttonbox">
              <button @click="register" class="primary">Doel afstemmen</button>
              <button @click="step = 2" class="secondary">Terug</button>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- metermodal -->
    <modalWindow class="metermodal" v-show="meterModal" @close="meterModal=false">
      <div class="titlebar">Profiel</div>
      <div class="inset">
        De Doelmeter geeft aan dat uw doel de grootste haalbaarheid heeft wanneer u gaat beleggen in
        Profiel{{'\xa0'}}{{ satProfile }}.
        <br /><br />
        <a
          target="_blank" class="button"
          href="https://www.doelbeleggen.nl/content/uploads/Beleggingsprofielen.pdf"
        >
          <awesomeIcon icon="file-alt" /> Bekijk onze beleggingsprofielen
        </a>
        <br /><br /><b>Haalbaarheid</b><br>
        Hoe hoger de haalbaarheid, hoe beter. Zo geeft een haalbaar&shy;heid van minder dan 50% aan
        dat uw doel onzekerder wordt. Met een haalbaar&shy;heid van 50% en hoger bouwt u een buffer
        voor mindere tijden.<br><br>
        Om uw haalbaarheid te verhogen, kunt u de inleg verhogen en/of looptijd verlengen. U kunt
        uiteraard ook altijd bellen met onze adviseurs op 020 - 555 00 55.
      </div>
    </modalWindow>
    <!-- goalmodal -->
    <modalWindow class="goalmodal" v-if="goalModal" @close="goalModal=false">
      <div class="titlebar">Doel</div>
      <div class="inset">
        U gaat {{durationPeriod}} jaar beleggen met een inleg van &euro;{{'\xa0'}}
        {{ formatPrice(Number(startValue), true) }} en een maandelijkse storting van
        &euro;{{'\xa0'}}{{ formatPrice(Number(depositValue), true) }}. Over uw uiteindelijke
        vermogen betaalt u elk jaar rendementsheffing en inflatie. Wilt u deze lasten meenemen
        in uw doelvermogen?
      </div>
      <customInput
        v-model="inflation" type="yesno"
        :label="'2% inflatie'"
      />
      <customInput
        v-model="wealthTax"  type="yesno"
        :label="'1,2% rendementsheffing'"
      />
      <customInput
        v-model="extraInterest" type="percentage"
        label="Wat wilt u aan extra rendement?"
      />
      <div class="inset">
        Streefrendement
        <b>{{formatPrice(
          (Number(extraInterest) / 100)
          + (wealthTax == 'Yes' ? 1.2 : 0)
          + (inflation == 'Yes' ? 2 : 0),
          false, 1)}}%
        </b><br>
        Doelvermogen
        <b> &euro; {{formatPrice(berekenVermogensopbouw(), true)}},-</b>
        <button @click="goalModal=false">
          Doelvermogen invullen
        </button>
      </div>
    </modalWindow>
  </div>
</template>

<script>
import scoreMeter from '../ui/scoreMeter';
import projectWidget from '../intake/project2';

export default {
  components: {
    scoreMeter,
    projectWidget,
  },
  name: 'RegisterPageWealth',
  data() {
    return {
      style: process.env.STYLE,
      msg: { msg: null, type: 'notice' },
      step: 0,
      goalResponse: {},
      satScore: 50,
      pvviData: {},
      targetDate: '',
      meterModal: false,
      goalModal: false,
      satProfile: 'Doelbeleggen E',
      startValue: '1500',
      depositValue: '50',
      durationPeriod: '10',
      extraInterest: '500',
      wealthTax: 'No',
      inflation: 'No',
      goalValue: '0',
    };
  },
  mounted() {
    this.sat();
  },
  methods: {
    update() {
      this.sat();
    },
    sat() {
      this.sdk.freeSat(
        // goalValue
        String(this.goalValue),
        // years
        String(this.durationPeriod),
        // start
        String(this.startValue),
        // depositValue
        String(this.depositValue),
        // depositInterval
        'M',
        // profile
        '',
        // response
        (response) => {
          if (response.status === 200) {
            this.satScore = response.data.score;
            this.pvviData = response.data.pvvidata;
            this.setProfile(response.data.pvvidata[0].vProfile);
            this.targetDate = response.data.otp
              .match('targetDate=[0-9]{4}-[0-9]{2}-[0-9]{2}')[0]
              .slice(11);
          }
        },
      );
    },
    berekenVermogensopbouw() {
      let doelvermogen = Number(this.startValue);
      const rendement = (Number(this.extraInterest) / 100)
        + (this.wealthTax === 'Yes' ? 1.2 : 0)
        + (this.inflation === 'Yes' ? 2 : 0);

      const bedrag = this.depositValue;
      for (let i = 0; i < this.durationPeriod; i += 1) {
        doelvermogen += (Number(bedrag) * 6);
        doelvermogen *= (1 + (rendement / 100));
        doelvermogen += (Number(bedrag) * 6);
      }

      this.goalValue = Math.round(doelvermogen);
      this.update();

      return doelvermogen;
    },
    register() {
      this.sdk.register(
        // username
        this.$refs.email.value,
        // email
        this.$refs.email.value,
        // callback
        (response) => {
          if (response.status === 200) {
            window.location.href = `?intake=${response.data.intake}`;
          } else if (response.status === 401) {
            this.msg = { msg: 'E-mailadres al in gebruik.', type: 'notice' };
          } else if (response.status === 403) {
            this.msg = { msg: 'E-mailadres incorrect.', type: 'notice' };
            this.msg.type = 'error';
          } else {
            this.msg = { msg: 'API onbereikbaar, probeer later opnieuw', type: 'notice' };
          }
        },
        // goal
        'grote-aankoop',
        // advisor
        '22223',
        // monthly
        String(this.depositAmount),
        // years
        String(this.durationPeriod),
        // target
        String(this.goalValue),
        // start
        String(this.startValue),
      );
    },
    setProfile(profile) {
      if (profile === 'DB6') {
        this.satProfile = 'Doelbeleggen E';
      } else if (profile === 'DB5') {
        this.satProfile = 'Doelbeleggen D';
      } else if (profile === 'DB4') {
        this.satProfile = 'Doelbeleggen C';
      } else if (profile === 'DB3') {
        this.satProfile = 'Doelbeleggen B';
      } else if (profile === 'DB2') {
        this.satProfile = 'Doelbeleggen A';
      } else if (profile === 'DB1') {
        this.satProfile = 'Sparen';
      } else {
        this.satProfile = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.goalmodal {
  .content {
    padding: 20px;
    padding-top: 20px;
    max-width: 400px;
    background-color: $color-lightgrey2;
    > * {
      margin: 10px 0;
    }
    button {
      width: 100%;
      margin-bottom: 0px;
    }
  }
  .close-button-modal {
    color: #000;
    margin: 0;
  }
}
.inputbox {
  border-radius: 3px;
  background-color: #fff;
  margin-top: 5px;
  &:before {
    display: none;
  }
  &:hover {
    background-color: #fff;
  }
  &:first-child {
    margin-top: 0;
  }
}
.form-error,
.form-notice,
.form-success {
  border-radius: 2px;
  max-width: 800px;
  margin: 0 auto 20px;
}
.formgroup {
  input[type='radio'] {
    width: auto;
    margin-right: 10px;
  }
  label {
    float: left;
    clear: left;
    margin-bottom: 10px;
  }
}
::placeholder {
  color: rgba(0,0,0,.5);
}
.card {
  border-radius: 4px;
  color: $color-background;
  overflow: hidden;
  background-color: $color-lightgrey2;
  max-width: 800px;
  margin: 0 auto;
  box-sizing: border-box;
  box-shadow: none;
  @media #{$desktop} {
    padding: 40px;
    padding-bottom: 100px;
  }
  @media #{$mobile} {
    padding: 20px;
    padding-bottom: 80px;
  }
  p,
  h2 {
    color: $color-background;
    margin: 20px 0px 20px 0px;
    width: 100%;
  }
  h3 {
    margin-bottom: 5px;
  }
  a {
    text-decoration: underline;
    font-weight: 600;
  }
  .buttonbox {
    position: absolute;
    @media #{$desktop} {
      bottom: 40px;
      right: 40px;
      left: 40px;
    }
    @media #{$mobile} {
      bottom: 20px;
      right: 20px;
    }
    button {
      float: right;
      &.secondary {
        padding: 10px 20px;
        margin-right: 20px;
      }
    }
  }
  .riskmeter {
    cursor: pointer;
    border-radius: 4px;
    &:hover {
      background-color: rgba(0,0,0,.1);
    }
    @media #{$mobile} {
      padding: 0 30px;
      margin-bottom: -20px;
    }
    .info {
      float: right;
      margin-top: 5px;
      margin-right: 5px;
    }
  }
  ul {
    padding-left: 12px;
  }
  .graph {
    margin-top: 20px;
  }
}
</style>
